module.exports = __webpack_public_path__ + "static/media/boxing.bafd66ed.jpg";